const MS_PER_DAY = 24 * 60 * 60 * 1000;
import { parseBookingWallClock } from "./wall-clock";

function timeStringToHHMM(time?: string | null): string | null {
  if (!time) return null;
  const m = String(time).trim().match(/^(\d{1,2}):(\d{2})\s*(am|pm)?$/i);
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const min = parseInt(m[2], 10);
  const period = m[3]?.toLowerCase();
  if (period === "pm" && h !== 12) h += 12;
  if (period === "am" && h === 12) h = 0;
  return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}:00`;
}

function toDate(d: string | Date, time?: string | null): Date {
  if (d instanceof Date) return new Date(d.getTime());
  const trimmed = String(d).trim();
  const t = timeStringToHHMM(time) ?? "00:00:00";
  return parseBookingWallClock(/^\d{4}-\d{2}-\d{2}$/.test(trimmed) ? `${trimmed}T${t}Z` : trimmed)?.date ?? new Date(NaN);
}

/**
 * Selected local-clock 24-hour chargeable day count. Mirrors the api-server's
 * `calculateChargeableDays`. Returns max(1, ceil((dropoff - pickup) /
 * 86_400_000)).
 *
 * When `pickupTime`/`dropoffTime` are omitted, both are treated as 00:00,
 * which makes the result equivalent to a calendar-day count for date-only
 * inputs.
 */
export function calculateChargeableDays(
  pickup: string | Date,
  dropoff: string | Date,
  pickupTime?: string | null,
  dropoffTime?: string | null,
): number {
  const start = toDate(pickup, pickupTime);
  const end = toDate(dropoff, dropoffTime);
  if (isNaN(start.getTime()) || isNaN(end.getTime())) return 1;
  const diff = end.getTime() - start.getTime();
  if (diff <= 0) return 1;
  return Math.max(1, Math.ceil(diff / MS_PER_DAY));
}
